import $ from 'jquery';

import column from './column/column'

export default function(o,p){

  var row = p.data[0]

  var updateTitles =
    function(){
      for(var columnDiv of columnDivs){
        columnDiv.updateTitle()
      }
    }

  var columnDivs =
    _.compact(
      _.map(
        row.columns,
        function(data){
          return column(o,p,data,updateTitles)
        }
      )
    )

  var div =
    $('<div>')
    .css({
      display: 'table-row',
      position: 'absolute',
      height: '68px',
      top: 0,
      left: 0,
      right: 0,
    })
    .append(
      columnDivs,
    )

  return div;

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/header/header.js